import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import { getFieldOptions } from "../common/selectors";
import { notBlank } from "../common/general";
import { FormControl, FormHelperText } from "@material-ui/core";

import IntlInputLabel from "./IntlInputLabel";
import IntlSelect from "./IntlSelect";

const CustomizableSelect = props => {
  const {
    fieldOption,
    children,
    defaultLabel,
    value,
    onChange,
    onBlur,
    xs,
    sm,
    md,
    error,
    helperText,
  } = props;

  const fieldOptions = useSelector(getFieldOptions);
  const [showField, setShowField] = useState(true);
  useEffect(() => {
    if (fieldOptions[fieldOption]) {
      setShowField(!fieldOptions[fieldOption].hidden);
    } else {
      setShowField(true);
    }
  }, [fieldOptions, fieldOption]);

  const [label, setLabel] = useState("");
  useEffect(() => {
    if (
      fieldOptions[fieldOption] &&
      notBlank(fieldOptions[fieldOption].fieldLabel)
    ) {
      setLabel(fieldOptions[fieldOption].fieldLabel);
    } else if (notBlank(defaultLabel)) {
      setLabel(defaultLabel);
    } else {
      setLabel("No Label Defined");
    }
  }, [fieldOptions, fieldOption, defaultLabel]);

  const [fieldValue, setFieldValue] = useState("");
  useEffect(() => {
    if (notBlank(value)) {
      setFieldValue(value);
    } else if (
      fieldOptions[fieldOption] &&
      notBlank(fieldOptions[fieldOption].defaultValue)
    ) {
      setFieldValue(fieldOptions[fieldOption].defaultValue);
    }
  }, [fieldOptions, fieldOption, value]);

  const wrapGrid = element => {
    if (notBlank(xs) || notBlank(sm) || notBlank(md)) {
      return (
        <Grid item xs={xs ?? 12} sm={sm ?? 6} md={md ?? 6}>
          {element}
        </Grid>
      );
    } else {
      return element;
    }
  };

  return (
    showField &&
    wrapGrid(
      <FormControl
        fullWidth
        error={error}
        required={fieldOptions?.[fieldOption]?.required}
      >
        <IntlInputLabel id={fieldOption + "-label"}>{label}</IntlInputLabel>
        <IntlSelect
          labelId={fieldOption + "-label"}
          id={fieldOption}
          value={fieldValue}
          onChange={onChange}
          onBlur={onBlur}
        >
          {children}
        </IntlSelect>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>,
    )
  );
};

export default CustomizableSelect;
